/**
 * Bidirectional conversion between LabelSelector Label[] and LabelFilterInput[].
 * Shared by TextLabelFilterStep and ImageLabelFilterStep.
 */

import type { Label } from '@core/components/LabelSelector';
import type { LabelFilterInput } from '@moderation/domain/AbrFilter';

/** Convert LabelSelector Label[] to LabelFilterInput[] for text labels */
export function labelsToTextFilters(labels: Label[]): LabelFilterInput[] {
  return labels.map(l => ({
    labelId: l.labelId,
    minSeverity: l.severity,
  }));
}

/** Convert LabelFilterInput[] to LabelSelector Label[] for text labels */
export function textFiltersToLabels(filters: LabelFilterInput[]): Label[] {
  return filters.map(f => ({
    labelId: f.labelId,
    severity: f.minSeverity ?? undefined,
  }));
}

/** Convert LabelSelector Label[] to LabelFilterInput[] for image labels */
export function labelsToImageFilters(labels: Label[]): LabelFilterInput[] {
  return labels.map(l => ({
    labelId: l.labelId,
    minScore: l.scoreThreshold,
  }));
}

/** Convert LabelFilterInput[] to LabelSelector Label[] for image labels */
export function imageFiltersToLabels(filters: LabelFilterInput[]): Label[] {
  return filters.map(f => ({
    labelId: f.labelId,
    scoreThreshold: f.minScore ?? undefined,
  }));
}
